'use strict';

import moment from 'moment-timezone';

angular.module('docketbook')
  .controller('groupSettingsGeneralController', function (docketService, billingService, xeroService, userService, $scope, Restangular, $window, $state, $stateParams, $timeout, accessControl, Upload) {
    mixpanel.track("Opened GroupSettings-General Desktop");
    $scope.currentUser = accessControl.currentUser();
    $scope.currentState = $state.current;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.allTimezones = moment.tz.names();
    $scope.allTimeFormats = ['12HR', '24HR'];
    $scope.timeFormatDisplay = { '12HR': '12 Hour Time', '24HR': '24 Hour Time' };
    $scope.sampleCompany = accessControl.isSampleCompany();
    $scope.groupEdit = $scope.currentOrgGroup;
    $scope.apiPath = DOCKETBOOK_API_URL;
    $scope.xeroEndpoint = Restangular.all('organisations').one($scope.currentOrg.id).all('groups').one($scope.currentOrgGroup.id).all('xero');
    $scope.xeroOrg = null;
    $scope.orgEdit = $scope.currentOrg;
    $scope.data = { newName: '', loading: false }
    $scope.bankAccount = {
      loading: true,
      active: true,
	    primaryAccount: true,
    }


    $scope.canViewOrgSettings =
      $scope.currentOrg.globalAdministrators.includes($scope.currentUser.id)
      || $scope.userHasPermission('io.docketbook.uoapi.viewOrganisationSettings')

    if (!$scope.canViewOrgSettings) {
      $state.go('companySettings.groups', {orgId: $scope.currentOrg.id}, { location: 'replace' })
    }


    const getBankAccount = function (cb) {
      Restangular.all('organisations').one($scope.currentOrg.id).all('bank_accounts').customGET().then(accounts => {
        if (accounts.length > 0) {
          $scope.bankAccount = Object.assign($scope.bankAccount, accounts[0])
          cb && cb()
        }
        $scope.bankAccount.loading = false
      }, () => {});
    };

    $scope.saveBankAccount = function() {
      var bankAccountToSave = {}
      Object.keys($scope.editBankAccount).forEach(key => bankAccountToSave[key] = $scope.editBankAccount[key].toString())
      Object.assign(bankAccountToSave, {
        active: true,
	      primaryAccount: true,
      })
      if ($scope.bankAccount.id) {
        Restangular.all('organisations').one($scope.currentOrg.id).all('bank_accounts').one($scope.bankAccount.id).customPUT(bankAccountToSave).then(() => {
          getBankAccount(() => {
            $scope.closeEditBankAccountModal()
          })
        })
      } else {
        Restangular.all('organisations').one($scope.currentOrg.id).all('bank_accounts').customPOST(bankAccountToSave).then(() => {
          getBankAccount(() => {
            $scope.closeEditBankAccountModal()
          })
        })
      }
    }

    getBankAccount()

    $scope.logoLoading = false;

    $scope.goTo = function (href) {
      $window.location.href = href;
    }

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    /***** DATA *****/

    $scope.removeSampleComplete = function () {
      accessControl.refreshAndGetAllowedOrganisations(function (orgs) {
        $state.go('main.dashboard');
      })
    }

    $scope.removeSampleCompany = function () {
      Restangular.all('organisations').one($scope.currentOrg.id).customDELETE('sample/remove').then($scope.removeSampleComplete, $scope.removeSampleComplete);
    }

    docketService.getTemplates(null, function (templates) {
      $scope.allTemplates = templates;
    }, function (err) {
      $scope.allTemplates = [];
    });

    /***********************************/
    /**** Company Settings Controls ****/
    /***********************************/

    userService.getMembers(null, function (users) {
      $scope.orgUsers = users;
      var globalAdminUsers = [];
      // go through currentOrg globalAdmins and populate names
      for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
        for (var j = 0; j < $scope.orgUsers.length; j++) {
          if ($scope.currentOrg.globalAdministrators[i] == $scope.orgUsers[j].id) {
            globalAdminUsers.push($scope.orgUsers[j]);
          }
        }
      }
      $scope.currentOrg.globalAdminUsers = globalAdminUsers;
    });

    $scope.userIsXeroAuthenticated = function () {
      if (!$scope.currentUser.xeroAuthentication) {
        return false;
      }
      if (!$scope.currentUser.xeroAuthentication.authenticatedUntil) {
        return false;
      }
      if (moment($scope.currentUser.xeroAuthentication.authenticatedUntil).isBefore(moment())) {
        return false;
      }
      return true;
    }

    $scope.xeroReauth = function () {
      $scope.directReauthenticate();
    }

    $scope.xeroAuth = function () {
      $scope.xeroConnectLogin('xeroauth');
    }

    $scope.xeroConnect = function () {
      $scope.xeroConnectConfirm(null, function (response) {
        $scope.currentOrg.features.xero = response;
      });
    }

    $scope.fetchXeroOrg = function () {
      if ($scope.currentOrgGroup == null) {
        return;
      }
      $scope.xeroEndpoint.one('organisation').one('current').customGET().then(function (xeroOrg) {
        $scope.xeroOrg = xeroOrg;
        if ($stateParams.action && $stateParams.action == 'xeroauth' && xeroOrg) {
          $timeout(function () {
            $scope.xeroConnect();
          }, 500);
        }
      });
    }

    $scope.xeroDisable = function (cb) {
      $scope.xeroEndpoint.all('enablement').customPUT({
        enabled: false
      }).then(function (response) {
        $scope.xeroAuthenticated = false;
        $scope.currentOrg.features.xero = response;
        return accessControl.refreshCurrentUser();
      }).then(function () {
        $scope.currentUser = accessControl.currentUser();
        cb && cb()
      })
    }

    $scope.toggleXeroQuotes = function () {
      $scope.xeroQuotesEnableLoading = true;
      var settingsUpdate = {};
      if ($scope.currentOrg.features.xero.quotesEnabled) {
        // disable and save
        settingsUpdate.quotesEnabled = false;
      } else {
        // enable and save
        settingsUpdate.quotesEnabled = true;
      }
      $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
        $scope.currentOrg.features.xero.quotesEnabled = settingsUpdate.quotesEnabled;
        $scope.xeroQuotesEnableLoading = false;
        return;
      });
    }

    $scope.toggleXeroDisplayPrices = function () {
      $scope.xeroPricesEnableLoading = true;
      var settingsUpdate = {};
      if ($scope.currentOrg.features.xero.displayUnitPrices) {
        // disable and save
        settingsUpdate.displayUnitPrices = false;
      } else {
        // enable and save
        settingsUpdate.displayUnitPrices = true;
      }
      $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
        $scope.currentOrg.features.xero.displayUnitPrices = settingsUpdate.displayUnitPrices;
        $scope.xeroPricesEnableLoading = false;
        return;
      });
    }

    $scope.toggleXeroInvoicePrices = function () {
      $scope.xeroInvoicePricesEnableLoading = true;
      var settingsUpdate = {};
      if ($scope.currentOrg.features.xero.invoicePricesInheritFromQuote) {
        // disable and save
        settingsUpdate.invoicePricesInheritFromQuote = false;
      } else {
        // enable and save
        settingsUpdate.invoicePricesInheritFromQuote = true;
      }
      $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
        $scope.currentOrg.features.xero.invoicePricesInheritFromQuote = settingsUpdate.invoicePricesInheritFromQuote;
        $scope.xeroInvoicePricesEnableLoading = false;
        return;
      });
    }

    $scope.toggleXeroDocketPdfDisplayPrices = function () {
      $scope.xeroDocketPdfPricesEnableLoading = true;
      var settingsUpdate = {};
      if ($scope.currentOrg.features.xero.docketPdfDisplayUnitPrices) {
        // disable and save
        settingsUpdate.docketPdfDisplayUnitPrices = false;
      } else {
        // enable and save
        settingsUpdate.docketPdfDisplayUnitPrices = true;
      }
      $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
        $scope.currentOrg.features.xero.docketPdfDisplayUnitPrices = settingsUpdate.docketPdfDisplayUnitPrices;
        $scope.xeroDocketPdfPricesEnableLoading = false;
        return;
      });
    }

    $scope.toggleXeroInteractionOnInvoice = function () {
      $scope.xeroInteractionOnInvoiceLoading = true;
      var settingsUpdate = {};
      if ($scope.currentOrg.features.xero.includeInteractionOnInvoice) {
        // disable and save
        settingsUpdate.includeInteractionOnInvoice = false;
      } else {
        // enable and save
        settingsUpdate.includeInteractionOnInvoice = true;
      }
      $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
        $scope.currentOrg.features.xero.includeInteractionOnInvoice = settingsUpdate.includeInteractionOnInvoice;
        $scope.xeroInteractionOnInvoiceLoading = false;
        return;
      });
    }

    $scope.xeroContactSync = function () {
      $scope.xeroContactSyncLoading = true;
      xeroService.xeroContactSync(function (taskInfo) {
        if (taskInfo.status == 'Failed') {
          //$scope.alertService.presentAlert('error', "We couldn't sync your Xero Contacts", "Something went wrong when we tried to sync your Xero Contacts. Please try again or contact support if this error persists.")
          //$scope.xeroContactSyncLoading = false;
          $scope.xeroDisable(function () {
            $scope.xeroAuth()
          })
        } else {
          $scope.xeroContactSyncLoading = false;
          $scope.showContactSyncSuccess = true;
        }
      })
    }

    $scope.xeroItemSync = function () {
      $scope.xeroItemSyncLoading = true;
      xeroService.xeroItemSync({}, function (taskInfo) {
        if (taskInfo.status == 'Failed') {
          $scope.alertService.presentAlert('error', "We couldn't sync your Xero Items", "Something went wrong when we tried to sync your Xero Items. Please try again or contact support if this error persists.")
          $scope.xeroContactSyncLoading = false;
        } else {
          $scope.xeroItemSyncLoading = false;
          $scope.showItemSyncSuccess = true;
        }
      })
    }


    $scope.xeroAuthenticated = $scope.userIsXeroAuthenticated();

    if ($scope.xeroAuthenticated) {
      $scope.fetchXeroOrg();
    }

    $scope.uploadNewLogo = function ($file) {
      $scope.logoLoading = true;
      Upload.upload({
        method: 'POST',
        url: DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + "/logo",
        data: { file: $file },
        withCredentials: true
      }).then(function (resp) {
        var url = DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/logo';
        $("#orgLogoImage").attr('src', url);
        $scope.logoLoading = false
        $scope.alertService.presentAutoAlert('uploadOrgLogo', resp);
        $scope.currentOrg.logoAttachmentName = "logo";
      }, function (resp) {
        $scope.logoLoading = false;
        $scope.alertService.presentAutoAlert('uploadOrgLogo', resp);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      });
    }

    $scope.editName = function () {
      $scope.data = {
        newName: $scope.currentOrg.name,
        loading: false
      }
      $scope.editingName = true
    }

    $scope.cancelEditName = function () {
      $scope.editingName = false
    }

    $scope.saveEditName = function () {
      $scope.data.loading = true
      userService.updateOrganisation($scope.currentOrg.id, { name: $scope.data.newName }, function (updatedOrg) {
        $scope.currentOrg = updatedOrg
        $scope.data.loading = false
        $scope.editingName = false
      }, function (err) {
        swal({
          title: "Oops!",
          text: "Unable to update organisation name. Please try again later",
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        $scope.data.loading = false
      })
    }

    $scope.showEditBankAccount = function () {
      $("#editBankAccountModal").fadeIn(100);
      $scope.editBankAccount = {
        loading: false,
        bankAccountName: '',
        bankAccountBsb: '',
        bankAccountNumber: undefined,
      };
    }

    $scope.closeEditBankAccountModal = function () {
      $("#editBankAccountModal").fadeOut(100);
    }

    $scope.searchAbn = function () {
      $("#searchAbnModal").fadeIn(100);
      $scope.abnSearch = { loading: false, abn: "", step: 'search', error: false };
    }

    $scope.closeSearchAbnModal = function () {
      $("#searchAbnModal").fadeOut(100);
    }

    $scope.searchAbnContinue = function (abnSearch) {
      abnSearch.loading = true;
      var abn = abnSearch.abn.replace(/\s+/g, '');
      billingService.searchAbn(abn, function (abnReturned) {
        abnSearch.loading = false;
        abnSearch.step = 'check';
        abnSearch.abnName = abnReturned.abnName;
        abnSearch.error = false;
      }, function (err) {
        abnSearch.loading = false;
        abnSearch.error = true;
      });
    }

    $scope.saveAbnSearch = function (abnSearch) {
      abnSearch.loading = true;
      var abn = abnSearch.abn.replace(/\s+/g, '');
      var updatePayload = { identities: { abn: abn } };
      userService.updateOrganisation($scope.currentOrg.id, updatePayload, function (updatedOrg) {
        $scope.closeSearchAbnModal();
        $scope.currentOrg.identities = updatedOrg.identities;
      }, function (err) {
        abnSearch.step = 'search';
        abnSearch.loading = false;
        abnSearch.saveError = true;
        abnSearch.error = false;
      });
    }

    $scope.abnModalBack = function (abnSearch) {
      abnSearch.step = 'search';
    }


    /**** Other Group Settings Controls ****/

    $scope.editOrgGroup = function (group) {
      $scope.groupEdit = { loading: true };
      userService.getOrganisationGroup(group.id, function (groupFull) {
        $scope.groupEdit = groupFull;
        $scope.groupOriginal = angular.copy(groupFull);
        $scope.newMember = {};
        // get org group members
        userService.getGroupMembers({ 'sort': 'first', 'groupId': group.id }, function (membersUserInfo) {
        }, function (err) {
        });
        if ($scope.groupEdit.root) {
          // get full org also
          $scope.orgEdit = $scope.currentOrg;
          $scope.orgOriginal = angular.copy($scope.currentOrg);
        }
      }, function (err) {
        $scope.groupEdit.loading = false;
        //$scope.closeGroupEdit();
        $scope.alertService.presentAutoAlert('getOrgGroup', err);
      });
    }


    if ($scope.canViewOrgSettings) {
      $scope.editOrgGroup($scope.currentOrgGroup);
    }

    $scope.saveOrgGroup = function (group) {
      group.loading = true;
      // get diff and save if diffcount > 0
      userService.getGroupDiff($scope.groupOriginal, group, function (diffCount, diff) {
        if (diffCount > 0) {
          if (group.id == null) {
            diff.parent = $scope.currentOrgGroup.id;
          }
          userService.saveOrganisationGroup(diff, function (groupUpdated) {
            //group.loading = false;

            if (group.root) {
              userService.getOrgDiff($scope.orgOriginal, $scope.orgEdit, function (diffCount, diff) {
                if (diffCount > 0) {
                  userService.updateOrganisation($scope.orgOriginal.id, diff, function (success) {
                    group.loading = false;
                    $scope.editOrgGroup(groupUpdated);
                  }, function (fail) {
                    group.loading = false;
                    $scope.editOrgGroup(groupUpdated);
                    alert('Error updating organisation');
                  });
                } else {
                  group.loading = false;
                  $scope.editOrgGroup(groupUpdated);
                }
              });
            } else {
              group.loading = false;
              $scope.editOrgGroup(groupUpdated);
            }
          }, function (err) {
            group.loading = false;
            $scope.alertService.presentAutoAlert('saveOrgGroup', err);
          });
        } else if (group.root) {
          userService.getOrgDiff($scope.orgOriginal, $scope.orgEdit, function (diffCount, diff) {
            if (diffCount > 0) {
              userService.updateOrganisation($scope.orgOriginal.id, diff, function (success) {
                group.loading = false;
                $scope.editOrgGroup($scope.currentOrgGroup);
              }, function (fail) {
                group.loading = false;
                $scope.editOrgGroup(groupUpdated);
                alert('Error updating organisation');
              });
            } else {
              group.loading = false;
              $scope.editOrgGroup(groupUpdated);
            }
          });
        } else {
          group.loading = false;
        }
      });
    }

    if ($stateParams.action && $stateParams.action == 'contactsync') {
      $timeout(function () {
        $scope.xeroContactSync();
      }, 1000);
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/groupSettings/general.js